import { Component, input } from '@angular/core';
import { FormArray, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TierFormGroup } from '../types';
import { TierRowComponent } from './tier-row/tier-row.component';
import { createTierGroup } from '../pricing-form';

@Component({
    selector: 'app-tier-pricing-editor',
    templateUrl: './tier-pricing-editor.component.html',
    styleUrls: ['./tier-pricing-editor.component.scss'],
    imports: [ReactiveFormsModule, TranslateModule, ButtonModule, TierRowComponent],
})
export class TierPricingEditorComponent {
    readonly tiers = input.required<FormArray<TierFormGroup>>();

    addTier(): void {
        const tiers = this.tiers();
        const last = tiers.at(tiers.length - 1);
        const seedMin = last ? (last.controls.maxUsers.value ?? last.controls.minUsers.value) + 1 : 1;
        tiers.push(createTierGroup({ minUsers: seedMin }));
    }

    removeTier(index: number): void {
        this.tiers().removeAt(index);
    }
}
